export const getPriceRange = (percentage: number, price: string | number | null | undefined) => {
  const priceDeviation = Number(price) * percentage;
  const maxLimit = Number(price) + priceDeviation;
  const minLimit = Number(price) - priceDeviation;

  if (typeof price == 'undefined') return { minLimit: 0, maxLimit: Number.MAX_SAFE_INTEGER };

  return { minLimit, maxLimit };
};
